import { render, staticRenderFns } from "./ListOfNotifications.vue?vue&type=template&id=0bc75b7a&scoped=true"
import script from "./ListOfNotifications.vue?vue&type=script&lang=js"
export * from "./ListOfNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc75b7a",
  null
  
)

export default component.exports